module.exports = __webpack_public_path__ + "static/img/sumup_ok.31e878a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sumup_ok.png
// module id = DTLl
// module chunks = 1